import type { Evt } from './envelope';

export type PlatformId =
  | 'web'
  | 'capacitor-ios'
  | 'capacitor-android'
  | 'rn-webview';

/** 네이티브가 실제로 제공하는 기능. 핸드셰이크에서 협상하고, 없으면 웹 폴백으로 내려간다. */
export interface Capabilities {
  keepAwake: boolean;
  immersive: boolean;
  haptics: boolean;
  fileExport: boolean;
  reminders: boolean;
  deviceProfile: boolean;
}

export interface DeviceProfile {
  platform: PlatformId;
  userAgent: string;
  /** 네이티브가 알려준 모델명. 웹에서는 null. */
  model: string | null;
  osVersion: string | null;
  devicePixelRatio: number;
  screenCssPx: { w: number; h: number };
  /** 네이티브가 보고한 디스플레이 주사율. 없으면 null → Clock 이 직접 측정한다. */
  nativeRefreshHz: number | null;
}

export type HapticKind = 'light' | 'success' | 'error';

export interface PlatformBridge {
  readonly platform: PlatformId;
  readonly capabilities: Capabilities;

  /** 어댑터 준비 + 네이티브 핸드셰이크. 실패해도 throw 하지 않고 능력만 비운다. */
  init(): Promise<void>;

  /** 화면 절전 차단. 세션 동안 켜고 끝나면 반드시 끈다. */
  keepAwake(on: boolean): Promise<void>;

  /** 전체화면 / 상태바·네비바 숨김. 자극의 시각적 크기를 세션 내내 고정하기 위한 것. */
  setImmersive(on: boolean): Promise<void>;

  haptic(kind: HapticKind): Promise<void>;

  /** 결과 파일 내보내기. 웹에서는 다운로드, 네이티브에서는 공유 시트. */
  exportFile(name: string, mime: string, data: Blob): Promise<void>;

  getDeviceProfile(): Promise<DeviceProfile>;

  /** 네이티브가 밀어주는 이벤트(앱 백그라운드 전환, 주사율 변경 등) 구독. 해제 함수를 반환. */
  onNativeEvent(cb: (e: Evt) => void): () => void;

  dispose(): void;
}

export const NO_CAPS: Capabilities = {
  keepAwake: false,
  immersive: false,
  haptics: false,
  fileExport: false,
  reminders: false,
  deviceProfile: false,
};
